import styles from './index.module.scss'
import classNames from 'classnames'
import Icon from 'common/Icon'
import { CINDER } from 'constants/colors'
import { Button } from 'react-bootstrap'

type ErrorBannerProps = {
  message: string | React.ReactNode
  isRedesign?: boolean
  closeToast?: () => void
  showWarningIcon?: boolean
}

const ErrorBanner: React.FC<ErrorBannerProps> = ({
  message,
  isRedesign,
  closeToast,
  showWarningIcon = false,
}) =>
  isRedesign ? (
    <div className={classNames(styles.error_banner_new, '~font-roboto')}>
      {showWarningIcon && (
        <Icon icon="warning" className={styles.warning_icon} fill={`#D2444A`} />
      )}
      <div className={`${styles.message}`}>{message}</div>
    </div>
  ) : (
    <div
      className={classNames(
        styles.banner_container,
        styles.error_banner,
        '~font-roboto',
        'd-flex align-items-center justify-content-between'
      )}
    >
      <div>{message || 'Opps something went wrong.'}</div>
      <Button variant="icon" onClick={closeToast} className="p-0">
        <Icon icon="close" fill={CINDER} className="fa-lg" />
      </Button>
    </div>
  )

export default ErrorBanner
